var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_579_801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.6109 24.5963C44.2038 24.3186 43.6489 24.4236 43.3715 24.8305L41.5503 27.5007C40.3992 22.1824 35.6547 18.1826 30.0001 18.1826C26.8434 18.1826 23.8758 19.4119 21.644 21.6442C21.2957 21.9926 21.2958 22.5573 21.6441 22.9055C21.9924 23.2539 22.5572 23.2539 22.9054 22.9054C24.8002 21.0101 27.3198 19.9665 30 19.9665C34.9139 19.9665 39.0162 23.5248 39.8682 28.1993L36.7042 26.0412C36.2971 25.7634 35.7422 25.8685 35.4648 26.2754C35.1872 26.6824 35.2921 27.2373 35.6992 27.5149L40.4221 30.7361C40.4224 30.7364 40.4227 30.7365 40.4229 30.7367C40.5382 30.8153 40.6654 30.8633 40.7949 30.8824C40.8379 30.8887 40.8813 30.8919 40.9246 30.8919C41.2096 30.8919 41.4896 30.7556 41.6623 30.5026L44.8452 25.8358C45.1228 25.4287 45.0178 24.8738 44.6109 24.5963Z",
    fill: "#730BDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2619 36.9238C35.3492 38.9292 32.7702 40.0336 29.9999 40.0336C25.0864 40.0335 20.984 36.4753 20.1319 31.801L23.2961 33.9591C23.4499 34.0639 23.6248 34.1142 23.7978 34.1142C24.0828 34.1142 24.3628 33.9781 24.5355 33.7249C24.8131 33.3179 24.7082 32.763 24.3012 32.4855L19.5783 29.2642C19.5781 29.2641 19.5779 29.2639 19.5776 29.2636C19.1704 28.9859 18.6158 29.0909 18.3382 29.4979L15.1551 34.1645C14.8777 34.5715 14.9824 35.1264 15.3894 35.404C15.5432 35.5089 15.7181 35.559 15.8911 35.559C16.1762 35.559 16.4561 35.4228 16.6288 35.1696L18.4499 32.4994C19.601 37.8176 24.3457 41.8172 29.9998 41.8172C33.2624 41.8172 36.3 40.5165 38.5526 38.1548C38.8926 37.7984 38.8793 37.2337 38.5229 36.8937C38.1662 36.554 37.6017 36.5673 37.2619 36.9238Z",
    fill: "#730BDB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_579_801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat);
export default __webpack_public_path__ + "static/media/repeat.30be3a93adbbb31df4bb3190c8acf91d.svg";
export { ForwardRef as ReactComponent };